import React, {useEffect} from "react";
import { connect } from "react-redux";

import WithOverlay from "../../../popups/withOverlayHoc";
import {setLookAllWallsTutorial} from "../../../../actions/lookFunctions";
import LookAllWallsTutorialHighlightFeature from "./lookAllWallsTutorialHighlightFeature";
import {IS_PRODUCT_JOURNEY} from "../../../../config";

const LookAllWallsTutorial = (props) => {

  const {lookAllWallsTutorial, setLookAllWallsTutorial, lookActiveCategory} = props;
  const {visible, finished, withGrid} = lookAllWallsTutorial;
  // const [anchorStyles, setAnchorStyles] = useState({});

  useEffect(() => {
    if (!lookActiveCategory && visible) {
      closeTutorial()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveCategory])

  const closeTutorial = () => {
    setLookAllWallsTutorial({
      visible: false,
      finished: true,
      lookFeature: null,
      withGrid: false,
      top: null,
      left: null,
      height: null,
      width: null,
    });
  }

  if (!visible || finished) {
    return null
  }

  return (
    <WithOverlay
      onClick={closeTutorial}
      className={"overlay--look-all-walls-tutorial" + (withGrid ? " overlay--look-locked-tutorial--grid" : "")
        + (IS_PRODUCT_JOURNEY ? " grohe-all-walls-tutorial-overlay" : "")}>
      {() => <LookAllWallsTutorialHighlightFeature/>}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookAllWallsTutorial, lookViewType} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookActiveCategory,
    lookAllWallsTutorial,
    lookViewType,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookAllWallsTutorial,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(LookAllWallsTutorial)
)
